import _typeof from "@babel/runtime/helpers/typeof";
var tokenKey = 'citrixRightSignatureToken';
var memoryToken = null;
export function getCachedToken() {
  var storage = getStorage();
  if (storage) {
    return storage.getItem(tokenKey);
  } else {
    return memoryToken;
  }
}
export function setCachedToken(token) {
  var storage = getStorage();
  if (storage) {
    storage.setItem(tokenKey, token);
  } else {
    memoryToken = token;
  }
}
function getStorage() {
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && window.sessionStorage) {
    return window.sessionStorage;
  }
}